import { NG_LANGS_WITHOUT_SUPPORT } from '@constants/global';

export const getOldNightgraphUrlLanguage = (lang: string) =>
  NG_LANGS_WITHOUT_SUPPORT.includes(lang) ? '' : `/${lang}`;
